module.exports = __webpack_public_path__ + "img/icon-ticket-active.f01134cf.svg";